import { StyleSheet } from 'react-native';
import { darkTheme } from '../../../src/theme/themes';
import { CUSTOMIZER_SURFACE } from './characterCustomizer.constants';

export const categoryRailStyles = StyleSheet.create({
  rail: {
    width: 62,
    flexGrow: 0,
    flexShrink: 0,
    borderRightWidth: 1,
    borderRightColor: CUSTOMIZER_SURFACE.railBorder,
  },
  railContent: {
    paddingVertical: 12,
    gap: 6,
  },
  button: {
    height: 52,
    marginHorizontal: 8,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonActive: {
    backgroundColor: CUSTOMIZER_SURFACE.railActiveBg,
  },
  buttonLocked: {
    opacity: 0.4,
  },
  lockBadge: {
    position: 'absolute',
    right: 6,
    bottom: 6,
    width: 16,
    height: 16,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: CUSTOMIZER_SURFACE.iconBtnBg,
  },
  marker: {
    position: 'absolute',
    left: -8,
    top: 14,
    width: 3,
    height: 24,
    borderRadius: 9999,
    backgroundColor: darkTheme.primary,
  },
});
